function arrRandomValue(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

function randomLetter(len) {
    if (!len && len !== 0) {
        len = 1;
    }

    var text = '';

    var possible = 'abcdefghijklmnopqrstuvwxyz';

    for (var i = 0; i < len; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
}

function randomNumber(min, max) {
    return Math.floor(Math.random() * (max-min+1)+min);
}

function unixTimestamp() {
    return Math.round((new Date()).getTime() / 1000);
}

function slugify(val) {
    val = val.replace(' ', '-');
    val = val.replace('&', '-');
    val = val.replace('"', '-');
    val = val.replace('\'', '-');
    return val;
}

module.exports = {
    arrRandomValue,
    randomLetter,
    randomNumber,
    unixTimestamp,
    slugify
};
